import { OrganizationKeyName } from "../../../model/Organization";
import { RootState } from "../../../store";

import * as authSelectors from "../../auth/authSelectors";
import { NewsListItem } from "../model/NewsListSuccessResponse";

const emptyNewsList: NewsListItem[] = [];
Object.freeze(emptyNewsList);

export const newsList = (state: RootState, org?: OrganizationKeyName) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.newsList || emptyNewsList;
};

export const isLoadingNewsList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.newsListIsLoading;
};

export const news = (
  state: RootState,
  id: string | undefined,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.news?.[id];
};

export const isLoadingNews = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!id) {
    return false;
  }

  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return !!state.shop.org[org]?.newsIsLoading[id];
};

export const upsertNewsErrors = (
  state: RootState,
  id?: string,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.upsertNewsErrors[id || "__new"];
};

export const newsUnassignedList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.newsUnassignedList || emptyNewsList;
};

export const isLoadingNewsUnassignedList = (
  state: RootState,
  org?: OrganizationKeyName
) => {
  if (!org) {
    org = authSelectors.selectedOrganizationKeyName(state);
  }

  return state.shop.org[org]?.newsUnassignedListIsLoading;
};
